import { createAction, props } from "@ngrx/store";
import { CheckData } from "../../create-request/models/check/CheckData";
import { ServiceError, ServiceErrorWithList } from "../../create-request/models/shared/ServiceError";
import { StandingAuthorizationForm } from "../models/standingAuthorizationForm";
import { StandingInstruction } from "../../shared/types/StandingInstruction";
import { CashieringTransaction, RecurringTransaction } from "../../create-request/models";
import { transactionTypes, ViewTypes } from "../../shared/utilities/Constants";
import { CheckInquiryResponse } from "../../create-request/models/check/CheckInquiryResponse";


export const callOneTimeInput = createAction(
    '[Create Standing Authorization - Check] Call Input',
    props<{isCheckSloa: boolean}>()
)

export const inputCallSuccessful = createAction(
    '[Create Standing Authorization - Check] Call to Input succeeded',
    props<{ checkInputResponse: CheckData }>()
)

export const inputCallFailed = createAction(
    '[Create Standing Authorization - Check] Call Input failed',
    props<ServiceError>()
)

export const callVerify = createAction(
    '[Create Standing Authorization - Check] Call Verify',
    props<StandingAuthorizationForm>()
);

export const verifyCallSuccessful = createAction(
    '[Create Standing Authorization - Check] Call to Verify succeeded',
    props<{ checkVerifyResponse: CheckData }>()
)

export const verifyCallFinishedWithError = createAction(
    '[Create Standing Authorization - Check] Call to Verify finished with an error',
    props<{ checkVerifyResponse: CheckData }>()
);


export const verifyCallFailed = createAction(
    '[Create Standing Authorization - Check] Call to Verify failed',
    props<ServiceErrorWithList>()
)

export const callAcknowledge = createAction(
    '[Create Standing Authorization - Check] Call to Check acknowledge'
  );

  export const acknowledgeCallSuccessful = createAction(
    '[Create Standing Authorization - Check] Call to Check acknowledge was successful',
    props<{ checkAcknowledgeResponse: CheckData}>()
  );

  export const acknowledgeCallFailed = createAction(
    '[Create Standing Authorization - Check] Call to Check acknowledge failed',
    props<ServiceErrorWithList>()
  );

  export const loadChecksReviewPageWithoutVerifyCall = createAction(
    '[Create Standing Authorization - Check] Load Check Review page without calling verify endpoint',
    props<StandingAuthorizationForm>()
  );

  export const callCheckInquiry = createAction(
    '[Create Standing Authorization - Check] Call to Check inquiry',
    props<{ payload: StandingInstruction | CashieringTransaction | RecurringTransaction, viewType: ViewTypes, transactionType: transactionTypes }>()
);

export const inquiryCallSuccessful = createAction(
    '[Create Standing Authorization - Check] Call to Check inquiry was successful ',
    props<{ checkInquiryResponse: CheckInquiryResponse }>()
);

export const inquiryCallFailed = createAction(
    '[Create Standing Authorization - Check] Call to Check inquiry failed',
    props<ServiceError>()
);
